import GiftBundleStrip from "./GiftBundleStrip";

export default GiftBundleStrip;
